import { render, staticRenderFns } from "./BlogText3Section.vue?vue&type=template&id=5cef54f5"
import script from "./BlogText3Section.vue?vue&type=script&lang=js"
export * from "./BlogText3Section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports